import { AffordabilityCalculator } from '@zillow/zhl-public-web-components';
import React from 'react';

var BlockAffordabilityCalculatorV2 = function BlockAffordabilityCalculatorV2() {
  return /*#__PURE__*/React.createElement(AffordabilityCalculator, {
    env: process.env.NEXT_PUBLIC_ENV === 'prod' ? 'prod' : 'dev'
  });
};
BlockAffordabilityCalculatorV2.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
var AffordabilityCalculatorV2 = BlockAffordabilityCalculatorV2;

export { AffordabilityCalculatorV2 as default };
